import * as z from 'zod/v4';

import { dateTimeSchema } from '../frameworks/entry.js';
import { competitionIdSchema, currencySchema, customerIdSchema, groupIdSchema } from '../lib/entry.js';

const channelSchema = z.enum(['internet', 'retail', 'spelombud']);

const capitalizeFirstLetter = (text: string): string => {
  const capitalizedText = text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  return capitalizedText;
};

const shareWinAmountSchema = z.object({
  share: currencySchema,
  group: currencySchema,
});

const drawNumberKeySchema = z.string().regex(/^\d+$/); // TODO: Branded DrawNumber type

const groupWinAmountsSchema = z.record(z.union([drawNumberKeySchema, z.literal('total')]), shareWinAmountSchema);

const wagerMarketplaceGroupPropertiesSchema = z
  .object({
    groupId: groupIdSchema,
    groupParticipatingMembers: z.array(customerIdSchema),
    totalShareCount: z.number(),
    customerShareCount: z.number(),
    groupWinAmounts: groupWinAmountsSchema,
  })
  .transform((marketplace) => {
    return {
      marketplace,
    };
  });

const competitionWagerPropertiesSchema = z
  .object({
    competitionIds: z.array(competitionIdSchema),
  })
  .transform((competition) => {
    return {
      competition,
    };
  });

const wagerPropertiesBase = z.object({
  time: dateTimeSchema,
  channel: channelSchema,
});

export const wagerPropertiesSchema = z
  .union([
    // All combinations sorted in the order of most specific first to least specific last
    wagerPropertiesBase.and(wagerMarketplaceGroupPropertiesSchema).and(competitionWagerPropertiesSchema),
    wagerPropertiesBase.and(wagerMarketplaceGroupPropertiesSchema),
    wagerPropertiesBase.and(competitionWagerPropertiesSchema),
    wagerPropertiesBase,
  ])
  .transform(({ time, channel, ...data }) => {
    const registrationInfo = { time, channel: capitalizeFirstLetter(channel) };
    let marketplace: z.infer<typeof wagerMarketplaceGroupPropertiesSchema>['marketplace'] | undefined;
    let competition: z.infer<typeof competitionWagerPropertiesSchema>['competition'] | undefined;

    if ('marketplace' in data) {
      marketplace = data.marketplace;
    }

    if ('competition' in data) {
      competition = data.competition;
    }

    // ensures type always returns the same shape
    return {
      registrationInfo,
      marketplace,
      competition,
    };
  });
